import styled from "styled-components"

import { minWidth } from "utils"

import Icon from "icons"
import CloudinaryImage from "components/cloudinary-image"
import CroppedImage from "components/cropped-image"

export const Wrapper = styled.div`
  position: fixed;
  z-index: 101;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
  overflow-y: auto;

  ${minWidth.mobile`
    display: none;
  `}
`

export const ScrollContainer = styled.div`
  width: 100%;
  margin: 7.2rem 0 2rem;
`

export const ScrollableGrid = styled.div`
  display: -webkit-box;
  overflow-x: auto;
`

export const Container = styled.div`
  width: 35rem;
  margin-right: 2rem;

  &:first-child {
    margin-left: 2rem;
  }
`

export const VideoImageWrapper = styled.div`
  position: relative;
  width: 35rem;
  height: 51.8rem;
  margin: 0 auto;
  border-radius: 0.4rem;
  overflow: hidden;
`

export const Video = styled.video`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
`

export const VideoPlayIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
`

export const VideoProgress = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 0.8rem;
  background-color: rgba(255, 255, 255, 0.4);
`

export const VideoProgressBar = styled.div`
  width: 0;
  height: 0.8rem;
  background-color: ${({ theme }) => theme.colors.primaryBlue};
  transition: width 0.25s linear;
`

export const ImageRegular = styled(CloudinaryImage)`
  width: 100%;
  height: 100%;
`

export const ImageCropped = styled(CroppedImage)`
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  width: 100%;
  margin-top: 2rem;
  padding: 1.2rem;
  border: 0.1rem solid rgba(34, 34, 34, 0.2);
  border-radius: 0.6rem;
  display: flex;
  align-items: center;
  background-color: #fff;
`

export const SmallImage = styled(CloudinaryImage)`
  width: 10rem;
  height: 10rem;
  flex: 1 0 auto;
`

export const Meta = styled.div`
  margin-left: 2rem;
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Title = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 2.496rem;
  color: #222;
`

export const Description = styled.p`
  margin: 0.7rem 0;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.184rem;
  color: #222;
`

export const BuyButton = styled.button`
  padding: 0.8rem;
  border-radius: 5rem;
  background-color: ${({ theme }) => theme.colors.primaryBlue};
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.62rem;
  letter-spacing: 0.1rem;
  text-align: center;
  color: #fff;
`

export const CloseIcon = styled(Icon)`
  position: absolute;
  top: 3.6rem;
  right: 3.6rem;
  color: #222;
  cursor: pointer;
`
